import React from 'react';
import RouteLoadingState from '../RouteLoadingState';
import { COMMON_TEXTS } from '../../../../utils/texts';

interface AuthenticationLoadingStateProps {
  message?: string;
  spinnerSize?: number;
}

const AuthenticationLoadingState: React.FC<AuthenticationLoadingStateProps> = ({
  message = COMMON_TEXTS.loading,
  spinnerSize = 80
}) => {
  return (
    <RouteLoadingState
      message={message}
      spinnerSize={spinnerSize}
      fullScreen={true}
      textVariant="h6"
    />
  );
};

export default AuthenticationLoadingState;